import { Role, User } from "../models/User";
import { Organization } from "../models/generics";
import { ColorVariables } from "../utils/uiVariables";
import client from "./axios";

const controlPanelUrl = `${window.__env.KRAKEND_URL}/v1/control-panel`;

interface RolesRespose {
  clientMappings: any;
  realmMappings: Role[];
}

export const ControlPanelManager = {
  getUsers: (params?: URLSearchParams) => client.get<User[]>(`${controlPanelUrl}/users`, { params }),
  getUser: (id: string) => client.get<User>(`${controlPanelUrl}/users/${id}`),
  createUser: (user: User) => client.post<User>(`${controlPanelUrl}/users`, user),
  updateUser: (user: User) => client.put<User>(`${controlPanelUrl}/users/${user.id}`, user),
  deleteUser: (id: string) => client.delete(`${controlPanelUrl}/users/${id}`),
  getRoles: () => client.get<Role[]>(`${controlPanelUrl}/roles`),
  createRole: (role: Role) => client.post<Role>(`${controlPanelUrl}/roles`, role),
  deleteRole: (id: string) => client.delete(`${controlPanelUrl}/roles/${id}`),
  getGroups: () => client.get<Organization[]>(`${controlPanelUrl}/groups`),
  getGroup: (id: string) => client.get<Organization>(`${controlPanelUrl}/groups/${id}`),
  getGroupMembers: (id: string) => client.get<User[]>(`${controlPanelUrl}/groups/${id}/members`),
  createGroup: (group: Organization) => client.post<Organization>(`${controlPanelUrl}/groups`, group),
  deleteGroup: (id: string) => client.delete(`${controlPanelUrl}/groups/${id}`),
  getUserGroups: (id: string) => client.get<Organization[]>(`${controlPanelUrl}/users/${id}/groups`),
  addUserToGroup: (userId: string, groupId: string) => client.post(`${controlPanelUrl}/users/${userId}/groups/${groupId}`),
  removeUserFromGroup: (userId: string, groupId: string) => client.delete(`${controlPanelUrl}/users/${userId}/groups/${groupId}`),
  getUserRoles: (id: string) => client.get<RolesRespose>(`${controlPanelUrl}/users/${id}/role-mappings`),
  addRolesToUser: (userId: string, roles: Role[]) => client.post(`${controlPanelUrl}/users/${userId}/role-mappings`, roles),
  removeRolesFromUser: (userId: string, roles: Role[]) => client.delete(`${controlPanelUrl}/users/${userId}/role-mappings`, { data: roles }),
  updateStyleVariables: (variables: ColorVariables) => client.post(`${controlPanelUrl}/customization/styles/variables`, variables),
  getStylesFile: () => client.get(`${controlPanelUrl}/customization/styles`),
  uploadStylesFile: (file: FormData) => client.post(`${controlPanelUrl}/customization/styles`, file),
  getEnvFile: () => client.get(`${controlPanelUrl}/customization/env`),
  uploadEnvFile: (file: FormData) => client.post(`${controlPanelUrl}/customization/env`, file),
  updateImage: (image: FormData) => client.post(`${controlPanelUrl}/customization/images`, image),
}